import React, { useEffect } from "react";
import HouseProgressBar from "@/components/subcomponents/HouseProgressBar";
import { useTitle } from "@/components/provider/TitleProvider";

const ForBusiness = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle("BuySooner For Business", "center");
  }, []);
  useEffect(() => {
    const body = document.querySelector("#root")!;
    body.scrollIntoView({
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="w-full grid grid-cols-1 sm:grid-cols-5 sm:grid-rows-[auto_auto_auto] gap-x-4 max-w-5xl mx-auto py-8">
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">Get the funds for your business now.</h5>
        <p style={{ color: "#57CB8F" }} className="text-3xl">
          <i className="bi bi-cash-stack"></i>
        </p>
      </div>
      <div className="row-span-3 flex items-center text-center px-2 py-4">
        <p className="text-sm text-gray-600">
          BuySooner for Business will give you funds to grow or to cover cashflow constraints and take a small temporary
          shareholding in your home.
        </p>
      </div>
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">Shared Ownership</h5>
        <HouseProgressBar
          id="mortgage"
          size={132}
          progress={80}
          fillColor="#57CB8F"
          baseColor="#3DA4ED"
          shares={{
            variant: 2,
            percentageOne: 95,
            percentageTwo: 5,
          }}
          shareLabels={{
            labelOne: "Owner",
            labelTwo: "5% BuySooner",
          }}
        />
      </div>
      <div className="row-span-3 flex items-center text-center px-2 py-4">
        <p className="text-sm text-gray-600">
          You can start contributing to gradually buy back our share as your business grows, or buy it all at once with
          a refinance after 3 years which we will help you get.
        </p>
      </div>
      <div className="grid grid-rows-subgrid row-span-3 justify-items-center text-center gap-3 py-4">
        <h5 className="text-lg font-semibold text-gray-900 self-end">100% Self Owned</h5>
        <HouseProgressBar
          id="mortgage"
          size={132}
          progress={100}
          fillColor="#3DA4ED"
          baseColor="#3DA4ED"
          shares={{
            variant: 3,
            percentageOne: 100,
            percentageTwo: 0,
          }}
        />
      </div>
    </div>
  );
};

ForBusiness.propTypes = {};

export default ForBusiness;
